import customSelect from 'custom-select'
import SimpleBar from 'simplebar'
import slugify from 'slugify'

export default {
  name: 'custom-select',

  componentDidMount () {
    const customSelectEl = customSelect(this.el, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <div class="custom-select-icon-wrapper">
        <svg class="custom-select-icon icon icon--indigo-blue">
          <use href="#icon-chevron-down" xlink:href="#icon-chevron-down"></use>
        </svg>
      </div>
    `

    customSelectEl[0].container.appendChild(iconContainer.firstElementChild)

    /* eslint-disable-next-line */
    new SimpleBar(customSelectEl[0].panel)

    customSelectEl[0].select.addEventListener('change', (e) => {
      if (e.target.value === '') {
        this.el.parentNode.parentNode.classList.add('has-placeholder')
      } else {
        this.el.parentNode.parentNode.classList.remove('has-placeholder')

        if (this.el.name === 'reason' && typeof _paq !== 'undefined') {
          _paq.push(['trackEvent', 'contact', 'formulaire', `filtre-form-${slugify(e.target.value.split('//')[0].toLowerCase())}`])
        }
      }
    })
  },
}
